import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const Quill = ReactQuill.Quill;
const Block = Quill.import("blots/block");
const Clipboard = Quill.import("modules/clipboard");

// ✅ Allow <table>, <tr>, <td> to survive paste
class TableBlock extends Block {}
TableBlock.tagName = ["TABLE", "TR", "TD"];
Quill.register(TableBlock, true);

// ✅ Extend clipboard to keep table HTML
class CustomClipboard extends Clipboard {
  convert(html = null) {
    const delta = super.convert(html);
    return delta;
  }
}
Quill.register("modules/clipboard", CustomClipboard, true);

export const quillModules = {
  toolbar: {
    container: [
      [{ font: [] }, { size: [] }],
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }, { background: [] }],
      [{ script: "sub" }, { script: "super" }],
      [{ header: "1" }, { header: "2" }, "blockquote", "code-block"],
      [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
      [{ direction: "rtl" }, { align: [] }],
      ["link", "image", "video"],
      ["clean"],
      ["insertTable"], // ✅ custom button
    ],
    handlers: {
      insertTable: function () {
        const tableHtml = `
          <table style="border-collapse: collapse; width: 100%;" border="1">
            <tr>
              <td style="padding: 5px;">Cell 1</td>
              <td style="padding: 5px;">Cell 2</td>
            </tr>
            <tr>
              <td style="padding: 5px;">Cell 3</td>
              <td style="padding: 5px;">Cell 4</td>
            </tr>
          </table><p><br></p>`;
        const range = this.quill.getSelection(true);
        if (range) {
          this.quill.clipboard.dangerouslyPasteHTML(range.index, tableHtml);
          this.quill.setSelection(range.index + 1);
        }
      },
    },
  },
  clipboard: {
    matchVisual: false, // ✅ keep HTML structure
  },
};

export const quillFormats = [
  "font", "size", "bold", "italic", "underline", "strike",
  "color", "background", "script", "header", "blockquote",
  "code-block", "list", "bullet", "indent", "direction", "align",
  "link", "image", "video", "table",
];

// ✅ Add toolbar titles dynamically
export function addToolbarTitles() {
  setTimeout(() => {
    const toolbarButtons = document.querySelectorAll(".ql-toolbar button, .ql-toolbar span");
    toolbarButtons.forEach((btn) => {
      if (btn.classList.contains("ql-bold")) btn.title = "Bold";
      if (btn.classList.contains("ql-italic")) btn.title = "Italic";
      if (btn.classList.contains("ql-underline")) btn.title = "Underline";
      if (btn.classList.contains("ql-strike")) btn.title = "Strike";
      if (btn.classList.contains("ql-insertTable")) btn.title = "Insert Table";
      if (btn.classList.contains("ql-link")) btn.title = "Insert Link";
      if (btn.classList.contains("ql-image")) btn.title = "Insert Image";
      if (btn.classList.contains("ql-video")) btn.title = "Insert Video";
      if (btn.classList.contains("ql-clean")) btn.title = "Clear Formatting";
    });
  }, 500);
}
